import { Card, Table } from 'antd';
import { useEffect, useState } from 'react'
import LayoutHeader from '../../adminnavigation/layoutHeader';
import { API } from '../../config/api';
import { GET } from '../../utils/apicalls';


function ContactInformation() {
    const [isLoading, setIsLoading] = useState(false);
    const [allModuleData, setallContact] = useState<any>([]);


    const feacthallCourseModule = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_CONTACT_INFORMATION, {});
            setallContact(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthallCourseModule();
    }, []);


    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "ConactName", dataIndex: "ConactName" },
        { title: "ContactEmail", dataIndex: "ContactEmail" },
        { title: "ContactPhoneNumber", dataIndex: "ContactPhoneNumber" },
        { title: "ContactSubject", dataIndex: "ContactSubject" },
        { title: "ContactMessage", dataIndex: "ContactMessage" },
    ];
    return (
        <div>
            <LayoutHeader />
            <h1 className="text-2xl font-bold mb-4 text-center" style={{ textAlign: "center" }}>Contact Information Management</h1>
            <Card>

                <Table
                    columns={columns}
                    dataSource={allModuleData}
                    loading={isLoading}
                    pagination={{ pageSize: 5 }}
                    scroll={{ x: "max-content" }}
                />
            </Card>

        </div>
    );
}

export default ContactInformation
